import React from 'react';
import { observer } from 'mobx-react-lite';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { PersonInfo, SUBSCRIBER_TYPES } from 'types/electionService';
import { DependentBlockKeyStyled, DependentBlockStyled, DependentBlockValueStyled, InfoStyled } from './styles';

interface DependentProps {
  dependent: PersonInfo;
}

interface DependentInfoRow {
  title: string;
  value: string;
}

const formatGender = (gender: string | undefined): string => {
  if (!gender) return '-';
  return gender === 'F' ? 'Female' : 'Male';
};

const DependentBlock = observer(({ dependent }: DependentProps): JSX.Element => {
  const dependentsInfo: DependentInfoRow[] = [
    {
      title: 'Relationship',
      value: (dependent.type && SUBSCRIBER_TYPES[dependent.type]) || '—',
    },
    {
      title: 'Name',
      value: [dependent.firstName, dependent.middleName, dependent.lastName].filter(Boolean).join(' '),
    },
    {
      title: 'Date of birth',
      value: dependent.dob ? dateFormatters.normDateToShortAmericanDate(dependent.dob) : '—',
    },
    {
      title: 'Gender',
      value: formatGender(dependent.gender),
    },
    {
      title: 'ZIP',
      value: dependent.zip ?? '—',
    },
    {
      title: 'State',
      value: dependent.zip_state ?? '—',
    },
    {
      title: 'City',
      value: dependent.city ?? '—',
    },
    {
      title: 'Street',
      value: [dependent.street, dependent.street2].filter(Boolean).join(', ') || '—',
    },
  ];

  return (
    <DependentBlockStyled>
      {dependentsInfo.map(({ title, value }) => (
        <InfoStyled key={title}>
          <DependentBlockKeyStyled>{title}</DependentBlockKeyStyled>
          <DependentBlockValueStyled>{value}</DependentBlockValueStyled>
        </InfoStyled>
      ))}
    </DependentBlockStyled>
  );
});

export default DependentBlock;
